export enum ExpirationTrackerStatus {
  ACTIVE = 'ACTIVE',
  RENEWED = 'RENEWED',
  CANCELLED = 'CANCELLED',
  ARCHIVED = 'ARCHIVED',
}

export enum AuditChangeType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum ExpirationNotificationStatus {
  SCHEDULED = 'SCHEDULED',
  SENT = 'SENT',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

export const ExpirationTrackerStatusColor: Record<ExpirationTrackerStatus, string> = {
  [ExpirationTrackerStatus.ACTIVE]: 'green',
  [ExpirationTrackerStatus.RENEWED]: 'blue',
  [ExpirationTrackerStatus.CANCELLED]: 'red',
  [ExpirationTrackerStatus.ARCHIVED]: 'gray',
}

export const ExpirationNotificationStatusColor: Record<ExpirationNotificationStatus, string> = {
  [ExpirationNotificationStatus.SCHEDULED]: 'blue',
  [ExpirationNotificationStatus.SENT]: 'green',
  [ExpirationNotificationStatus.FAILED]: 'red',
  [ExpirationNotificationStatus.CANCELLED]: 'gray',
}
